<template>
  <uploader
    @file-success="fileSuccess"
    :options="uploadOptions"
    @upload-start="onUploadStart"
  >
    <uploader-btn :single="true" :attrs="uploadAttrs">{{
      caption
    }}</uploader-btn>
  </uploader>
</template>

<script>
import { uuidv4 } from '@/api/uuid'

export default {
  name: 'PrintStoreFileUpload',
  props: {
    caption: {
      type: String
    },
    // Set this to true if the image should be stored as a preview
    isPreview: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      files: [],
      uploadOptions: {
        target: '/api/v2/print-store/file',
        testChunks: true,
        autoStart: true,
        chunkSize: 524288, // 0.5MB
        query: () => {
          return {
            isPreview: this.isPreview
          }
        },
        generateUniqueIdentifier: () => {
          return uuidv4()
        },
        permanentErrors: [404, 415, 422, 500, 501, 409]
      },
      uploadAttrs: {
        accept: 'image/jpeg, image/png'
      }
    }
  },
  methods: {
    onUploadStart() {
      this.$emit('uploadStart')
    },
    fileSuccess(rootFile, file, message, chunk) {
      this.$emit('uploadComplete', JSON.parse(message))
    }
  }
}
</script>
<style scoped lang="scss">
@use '../../sass/helpers/_variables.scss' as *;
@use '../../sass/helpers/_mixins.scss' as *;
@use '../../sass/base/_colors.scss' as *;
@use '../../sass/assets/_buttons.scss' as *;

// Styling the upload button as a pill-button
.uploader-btn {
  @extend .main-button;
}
</style>
